import { useNavigate } from 'react-router-dom';
import { RecipeForm } from '../components/RecipeForm';
import api from '@/lib/api';

export function RecipeCreatePage() {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <h1 className="text-2xl font-semibold">Create Recipe</h1>
      <RecipeForm
        onSubmit={async (data) => {
          const result = await api.createCraftingRecipe({ ...data });
          navigate(`/a/arche_crafting/admin/recipes/${result.recipe.recipeId}`);
        }}
        onCancel={() => navigate('/a/arche_crafting/admin')}
        submitLabel="Create"
      />
    </div>
  );
}
